import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { ChevronDown, ChevronUp } from "react-ikonate";

import styles from "./OptionsDropdown.module.css";
import classNames from "classnames";

/**
 *
 * An interactive custom Select used in the header of the groups page, users details page, and events details page.
 *
 */

export function OptionsDropdown({
  options,
  onChange,
  placeholder,
  openedPlaceholder,
  disabled,
}) {
  const [dropdownDisplay, changeDropDownDisplay] = useState(false);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          changeDropDownDisplay(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <div ref={wrapperRef} className={styles.container}>
      <button
        className={classNames(
          styles.selectDropdown,
          dropdownDisplay && styles.opened
        )}
        onClick={() => changeDropDownDisplay(!dropdownDisplay)}
        disabled={disabled}
      >
        <span>{!dropdownDisplay ? placeholder : openedPlaceholder}</span>
        <span className={styles.selectChevron}>
          <ChevronDown fontSize="1.4em" />
        </span>
      </button>

      {dropdownDisplay && (
        <div className={styles.selectOptions}>
          {options.map((option) => (
            <button
              className={styles.selectMenuOptions}
              key={option}
              onClick={() => {
                onChange(option);
                changeDropDownDisplay(false);
              }}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

OptionsDropdown.propTypes = {
  /**
   * List of options to map through
   */
  options: PropTypes.array.isRequired,
  /**
   * Function for when the user selects a new option
   */
  onChange: PropTypes.func.isRequired,
  /**
   * String that contains the default value shown in the dropdown
   */
  placeholder: PropTypes.string.isRequired,
  /**
   * 	Placeholder for when the dropdown opens
   */
  openedPlaceholder: PropTypes.string.isRequired,
  /**
   * Boolean that disables the dropdown
   */
  disabled: PropTypes.bool,
};

OptionsDropdown.defaultProps = {
  disabled: false,
};
